import ComponentsFactory from 'foundation/components-factory';
import BasketBuyLinksComponent from './js/basket-buy-links.component';

ComponentsFactory.getInstance().define('basket-buy-links', BasketBuyLinksComponent);
